import { Component,
    Input,
    ChangeDetectionStrategy,
    EventEmitter, 
    OnChanges, 
    OnInit, 
    SimpleChanges, 
    SimpleChange ,
    Output} from '@angular/core'
    import { CountryList } from "../interface/country-data";
    import { MydownlineData } from "../interface/downline-report-methods";
    import { CustomerService } from "../services/customer.service";
import { LocalStorageService } from 'angular-2-local-storage';
import { DistributorLevel } from '../enums/distributor-level.enum';
// import {  } from 'events';


@Component({
selector: "[trow]",
templateUrl: "../templates/template1/views/downline-report-row.component.html",
styleUrls: ["../templates/template1/themes/default/css/mydownline-report-row.component.less"]
})

export class MydownlineReportRowComponent implements OnChanges, OnInit {
requestObject: MydownlineData;

@Input() rowItem: any;
@Input() level: number = 0;
@Input() country:string;
@Input() expandingLevel: number = 1;
@Input() distributorLevel:string = "";
@Input() isOpen: boolean = true;
@Output() isOpenChange:EventEmitter<boolean> =new  EventEmitter<boolean>();
// @Output() onExpand:EventEmitter<any> = new EventEmitter<any>();

selectedindex: number = -1;
// isOpen: boolean = false;
downlineMembers: any[] = [];
expandedItems: any[] = [];

constructor(private _downline:CustomerService){}

getDownlineMembers(distributorId:string,generationValue:number): void {                
    this.expandedItems[this.rowItem.distributorId] = !this.expandedItems[this.rowItem.distributorId];
    if(distributorId !== null){
        if(this.expandedItems[this.rowItem.distributorId]){
  //          let requestObject = this.prepareDownlineMemberRequest(this.rowItem.distributorId,"",0,0,'',generationValue)            
        this._downline.getDownLineMemberDetail(this.rowItem.distributorId,"",0,0,this.country,'',false,'',0,generationValue)
        .subscribe(res => {                            
            if(res !== null){
                res.forEach((element:any)=> {
                    this.rowItem.downLineMembers = element.downLineMembers;                         
                });
                // this.onExpand.emit(this.rowItem);
            }                                                                      
        });
        this.isOpenChange.emit(true);
        }
        else{                                       
            this.rowItem.downLineMembers = [];
            this.isOpenChange.emit(false);
        }
        
    }
    
}
// onExpanded(event:any){
//     this.onExpand.emit(event);
// }

ngOnInit() {          
    if (this.level < this.expandingLevel) {
        this.getDownlineMembers(null,null);
    }
}

ngOnChanges(changes: SimpleChanges) {        
    const expandingLevel: SimpleChange = changes.expandingLevel===undefined?null:changes.expandingLevel;
    if(expandingLevel !== null){
        expandingLevel.previousValue = expandingLevel.previousValue === undefined ? this.expandingLevel : expandingLevel.previousValue;
    }
    
}
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/downline-report-row.component.ts